






import { Component, Prop, Vue } from 'vue-property-decorator'
import AuthService from '../services/AuthService'

@Component
export default class Callback extends Vue {
  @Prop() private auth!: AuthService
  public created () {
    this.auth.handleAuthentication()
  }
}
